import {Directive, ElementRef, EventEmitter, HostListener, Input, Optional, Output, ViewChild} from '@angular/core';
import {restrictChar, restrictSingleQuote, restrictXml} from "../common";
import {FormControl, NgControl} from "@angular/forms";

@Directive({
    selector: '[focusInOut]'
})
export class FocusInOutDirective {


    @Output() focusInOutChanged = new EventEmitter<any>();

    @ViewChild("input") myFormControl: FormControl;

    private readonly ngControl;

    // constructor(element: ElementRef, private ddd: DynamicFormComponent, private fc: NgControl) {
    constructor(fc: NgControl) {
        this.ngControl = fc;
    }

    @HostListener('focusout', ['$event'])
    focusout(event) {
        if (!this.ngControl) return;
        this.focusInOutChanged.emit(null);
        // some delay required otherwise `document.activeElement` is not yet set
        // setTimeout(() => {
        //     console.log('new focus', document.activeElement);
        // });
    }

    @HostListener('focusin', ['$event'])
    focusin(event) {
        if (!this.ngControl) return;
        this.focusInOutChanged.emit(this.ngControl.name);

    }

}
